import { render } from "./GlucoseSettingsView.vue?vue&type=template&id=1809dfac&scoped=true"
import script from "./GlucoseSettingsView.vue?vue&type=script&lang=js"
export * from "./GlucoseSettingsView.vue?vue&type=script&lang=js"

import "./GlucoseSettingsView.vue?vue&type=style&index=0&id=1809dfac&scoped=true&lang=scss"
import "./GlucoseSettingsView.vue?vue&type=style&index=1&id=1809dfac&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1809dfac"]])

export default __exports__